module.exports = __webpack_public_path__ + "static/media/background.3799b665.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/modules/brand/brands/football/media/background.jpg
// module id = 883
// module chunks = 0